import KRGlue from '@lyracom/embedded-form-glue';
import { useEffect } from 'react';
import Head from 'next/head';
import { toastError, toastSuccess } from '../Common/toasters';
import { useRouter } from 'next/router';
import Script from 'next/script';

const NEXT_PUBLIC_PAYZEN_PUBLIC_KEY = process.env
  .NEXT_PUBLIC_PAYZEN_PUBLIC_KEY as string;
const NEXT_PUBLIC_PAYZEN_API_ENDPOINT = process.env
  .NEXT_PUBLIC_PAYZEN_API_ENDPOINT as string;
const NEXT_PUBLIC_APP_URL = process.env.NEXT_PUBLIC_APP_URL as string;

type NormalizedClientAnswer = KRClientAnswer & {
  orderDetails: { orderId: string };
};

type Props = {
  formToken: string;
};

const PayzenCardForm = ({ formToken }: Props) => {
  const router = useRouter();
  const language = router.locale as SupportedLanguages;
  useEffect(() => {
    async function setupPaymentForm() {
      const endpoint = NEXT_PUBLIC_PAYZEN_API_ENDPOINT;
      const publicKey = NEXT_PUBLIC_PAYZEN_PUBLIC_KEY;

      try {
        const { KR } = await KRGlue.loadLibrary(
          endpoint,
          publicKey
        ); /* Load the remote library */

        await KR.setFormConfig({
          /* set the minimal configuration */ formToken: formToken,
          'kr-language': language,
        });

        await KR.onSubmit(async (paymentData) => {
          try {
            const response = await fetch(
              `${NEXT_PUBLIC_APP_URL}/api/validate-payment`,
              {
                method: 'POST',
                body: JSON.stringify(paymentData),
                headers: {
                  'Content-Type': 'application/json',
                },
              }
            );
            console.log('paymentData', paymentData);
            console.log('response', response);
            if (response.status === 200) {
              const orderId = (
                paymentData.clientAnswer as NormalizedClientAnswer
              ).orderDetails.orderId;

              router.push(`/purchase-success?orderId=${orderId}`);

              toastSuccess('¡Gracias por tu compra!');
            } else {
              toastError('Error intentando procesar el pago, intenta de nuevo');
            }
          } catch (error) {
            console.error('Error processing payment:', error);
            toastError('Error intentando procesar el pago, intenta de nuevo');
          }
          return false; // Return false to prevent the redirection
        });

        await KR.renderElements(
          '#myPaymentForm'
        ); /* Render the payment form into myPaymentForm div*/
      } catch (error) {
        console.error('Error loading payment form:', error);
      }
    }

    setupPaymentForm();
  }, [formToken, router]);

  return (
    <>
      <Head>
        <link
          rel="stylesheet"
          href="https://static.lyra.com/static/js/krypton-client/V4.0/ext/neon-reset.min.css"
        />
      </Head>
      <div className="flex flex-col items-center w-full py-6">
        <div id="myPaymentForm">
          {/* eslint-disable-next-line react/no-unknown-property */}
          <div className="kr-smart-form" kr-card-form-expanded></div>
        </div>
      </div>
    </>
  );
};

export default PayzenCardForm;
